import React from 'react'
import { NotificationMessage } from '../components'
import { SetNotification } from './NotificationProvider'

export interface NotificationContextInterface {
  notification: NotificationMessage | null
  setNotification: SetNotification
}

export const NotificationContext = React.createContext<NotificationContextInterface>({
  notification: null,
  setNotification: () => {
    return
  },
})
